// Updated GSAP ScrollTrigger script for all sections
// Make sure GSAP and ScrollTrigger are loaded before this script

// Wait until DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // === SECTION 1: Ambassadors Info Blocks Animation ===
  const infoBlocks = document.querySelectorAll('.ambassadors__info_block');
  
  if (infoBlocks.length) {
    infoBlocks.forEach((block) => {
      const title = block.querySelector('.ambassadors__info_block--title');
      const subtitle = block.querySelector('.ambassadors__info_block--subtitle');
      const text = block.querySelector('.ambassadors__info_block--text');
      const img = block.querySelector('.info_block-img');
      const coloredBox = block.querySelector('.ambassadors__info_colored--block');
      const coloredLinkSpan = coloredBox?.querySelector('.ambassadors__info_colored--block-link span');
  
      // Title fade from top
      if (title) {
        gsap.fromTo(title,
          { y: -20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: title,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Subtitle fade with delay
      if (subtitle) {
        gsap.fromTo(subtitle,
          { y: -10, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.5,
            delay: 0.1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: subtitle,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Text fade in
      if (text) {
        gsap.fromTo(text,
          { y: 10, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.5,
            delay: 0.15,
            ease: "power2.out",
            scrollTrigger: {
              trigger: text,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Image slide-in and fade (alternate left/right by index)
      if (img) {
        const isOdd = block.classList.contains('block-1') || block.classList.contains('block-3') || block.classList.contains('block-5');
        const fromX = isOdd ? 30 : -30;
      
        gsap.fromTo(img,
          { x: fromX, scale: 1.05, opacity: 0 },
          {
            x: 0,
            scale: 1,
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: img,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Colored Box slide up
      if (coloredBox) {
        gsap.fromTo(coloredBox,
          { y: 20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: "power2.out",
            scrollTrigger: {
              trigger: coloredBox,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Link span scale in
      if (coloredLinkSpan) {
        gsap.fromTo(coloredLinkSpan,
          { scale: 0.95, opacity: 0 },
          {
            scale: 1,
            opacity: 1,
            delay: 0.4,
            duration: 0.3,
            ease: "power2.out",
            scrollTrigger: {
              trigger: coloredLinkSpan,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
    });
  }

    // === SECTION 2: Ambassadors Header Animation ===
  const headerWrapper = document.querySelector('.ambassadors__header--wrapper');
  const headerTitle = document.querySelector('.ambassadors__header--body h1');
  const headerButton = document.querySelector('.ambassadors__header--link-1');

  if (headerWrapper) {
    gsap.fromTo(headerWrapper,
      { y: 30, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.7,
        ease: "power2.out",
        scrollTrigger: {
          trigger: headerWrapper,
          start: "top 85%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  if (headerTitle) {
    gsap.fromTo(headerTitle,
      { y: -20, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        delay: 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: headerTitle,
          start: "top 85%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  if (headerButton) {
    gsap.fromTo(headerButton,
      { y: 20, scale: 0.96, opacity: 0 },
      {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 0.55,
        delay: 0.2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: headerButton,
          start: "top 85%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  // === SECTION 3: Ambassadors Advantages Animation ===
  const advantagesWrapper = document.querySelector('.ambassadors__advantages--wrapper');
  const advantagesItems = document.querySelectorAll('.ambassadors__advantages--body li');

  if (advantagesWrapper) {
    gsap.fromTo(advantagesWrapper,
      { y: 25, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.65,
        ease: "power2.out",
        scrollTrigger: {
          trigger: advantagesWrapper,
          start: "top 85%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  if (advantagesItems.length) {
    advantagesItems.forEach((item, index) => {
      const img = item.querySelector('.item-img');

      gsap.fromTo(item,
        { y: 25, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          delay: index * 0.08,
          ease: "power2.out",
          scrollTrigger: {
            trigger: item,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );

      if (img) {
        gsap.fromTo(img,
          { scale: 0.9, opacity: 0 },
          {
            scale: 1,
            opacity: 1,
            duration: 0.45,
            delay: 0.15 + index * 0.08,
            ease: "back.out(1.4)",
            scrollTrigger: {
              trigger: item,
              start: "top 85%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
    });
  }

  // === SECTION 4: Feature Slider Animations ===
  const featureSlider = document.querySelector(".s-feature-slider");
  if (featureSlider) {
    const title = featureSlider.querySelector(".s-feature-slider__title");
    const slides = featureSlider.querySelectorAll(".s-feature-slider__slide");

    gsap.fromTo(
      featureSlider,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: featureSlider,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: featureSlider,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    slides.forEach((slide, index) => {
      gsap.fromTo(slide, { y: 40, opacity: 0 }, {
        y: 0,
        opacity: 1,
        duration: 0.6,
        delay: index * 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: slide,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      });
    });
  }

  // === SECTION 5: Catalog Download Animation ===
  const catalogSection = document.querySelector('.s-catalog-download');

  if (catalogSection) {
    const title = catalogSection.querySelector('.s-catalog-download__title');
    const text = catalogSection.querySelector('.s-catalog-download__text');
    const button = catalogSection.querySelector('.why-us-section__link');

    // Section fade-out
    gsap.fromTo(
      catalogSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: catalogSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    // Title animation
    if (title) {
      gsap.fromTo(
        title,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Text animation
    if (text) {
      gsap.fromTo(
        text,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.15,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: text,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Button animation (same style as others)
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.35,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // Always refresh ScrollTrigger to ensure layout is measured correctly
  ScrollTrigger.refresh();
});
